import React from "react";
import { Route, Switch } from "react-router-dom";
import { Path } from "paths";
import {
  ShiftList,
  TransactionList,
  ViewTransaction,
  ViewShift,
  EndOfDayReportList,
  UnSyncTransactionReport,
  MonthlySaleReport,
  OrderKpi
} from "modules";
import ViewEndOfDay from "modules/end-of-day-report/view-end-of-day/view-end-of-day.module";
import { useMount } from "hooks";
import { setPageTitle } from "services";

const TransactionPage = () => {
  useMount(() => {
    setPageTitle("transactions");
  });
  
  return (
    <Switch>
      <Route exact path={Path.UNSYNC_TRANSACTION} component={UnSyncTransactionReport} />
      <Route exact path={Path.MONTHLY_SALE_REPORT} component={MonthlySaleReport} />
      <Route exact path={Path.END_OF_DAY_REPORT} component={EndOfDayReportList} />
      <Route exact path={Path.VIEW_OF_DAY_REPORT_ID} component={ViewEndOfDay} />
      <Route exact path={Path.REGISTER_REPORT} component={ShiftList} />
      <Route exact path={Path.TRANSACTION} component={TransactionList} />
      <Route exact path={Path.VIEW_REGISTER_REPORT} component={ViewShift} />
      {/* Must come before VIEW_TRANSACTION (/transaction/:id) so "order-kpi" isn't
          swallowed as a transaction id. */}
      <Route exact path={Path.ORDER_KPI} component={OrderKpi} />
      <Route exact path={Path.VIEW_TRANSACTION} component={ViewTransaction} />
    </Switch>
  );
};

export default TransactionPage;
